var states = {}

class EventState {
  constructor(match) {
    this.match = match
    this.renderSet = new Set()
    this.reloadSet = new Set()
    this.reset()
  }

  listen(component, reload) {
    this.renderSet.add(component)
    if(reload) this.reloadSet.add(component)
  }

  render() {
    for(var component of this.renderSet) {
      component.render()
    }
  }

  reload(force) {
    if(this.$promise) return
    this.$promise = this.match.load({$reload: force})
    this.$promise
      .then(() => {
        for(var component of this.reloadSet) {
          component.update(this.$promise)
        }
      })
      .catch(err => console.error(err))
      .then(() => {
        delete this.$promise
      })
  }

  reset() {
    this.player = null
    this.subPlayer = null
    this.event = null
    this.subEvent = null
    this.minute = this.match.events
      ? this.match.events.reduce((n, e) => Math.max(n, e.minute), 0)
      : 0
    this.second = 0
    this.originalEvent = null
    this.render()
  }

  sanitize() {
    if(/substitution/.test(this.event) && this.player && this.subEvent) {
      var on = +!!this.player.isOn

      this.event = 'substitution_' + (on)
      this.subEvent = 'substitution_' + (1 - on)
    }
    if(/bonus/.test(this.event)) {
      if(!this.subEvent) {
        this.subEvent = this.event
      } else {
        this.event = this.subEvent
      }
    }
    if(!this.subEvent) {
      this.subPlayer = null
    }
  }

  isEvent(event) {
    if(event.match(/substitution/)) {
      return (this.event || '').match(/substitution/)
    } else if(event.match(/bonus/)) {
      return (this.event || '').match(/bonus/)
    }
    return this.event === event
  }

  assignPlayer(player) {
    if(this.canSubPlayer) {
      this.subPlayer = player
    } else {
      this.$team = null
      this.player = player
    }
    if((this.event || '').match('substitution_')) {
      this.subEvent = 'substitution_0'
    }
    this.sanitize()
    this.render()
  }

  assignTeam(team) {
    this.$team = team
    this.player = null
    this.render()
  }

  assignEvent(event) {
    this.event = event
    if((event || '').match('substitution_') && this.player) {
      this.subEvent = 'substitution_0'
    } else {
      this.subEvent = null
    }
    this.minute = Math.floor(this.match.durationMs / 60000)
    this.second = 0
    this.sanitize()
    this.render()
  }

  assignSubEvent(subEvent) {
    this.subEvent = subEvent
    this.sanitize()
    this.render()
  }

  assignMinute(minute) {
    this.minute = minute
    this.render()
  }

  assignSecond(second) {
    this.second = second
    this.render()
  }

  assignOriginal(original) {
    this.originalEvent = original
    this.event = original.name
    this.minute = original.minute
    this.second = original.second
    this.player = this.findLineup(original.player)
    if(!this.player) this.team = original.team
    if(original.subEvent) {
      this.subEvent = original.subEvent.name
      this.subPlayer = this.findLineup(original.subEvent.player)
    }
    this.sanitize()
    this.render()
  }

  findLineup(player) {
    return this.match.lineups.find(l => l.player === player)
  }

  create() {
    var ret = {}
    var name = this.event
    if(!this.isReady) throw new Error('not ready')
    if(name.match(/event/)) {
      name = this.subEvent
    } else if(name === 'blunder') {
      name = this.subEvent || 'penalty_caused'
    }
    ret.event = {
      minute: this.minute,
      second: this.second,
      name: name,
      match: this.match._id,
    }
    if(this.team) ret.event.team = this.team._id
    if(this.player) ret.event.player = this.player.playerId
    if(this.subPlayer) {
      ret.subEvent = Object.assign({}, ret.event, {
        player: this.subPlayer.playerId,
        name: this.subEvent,
      })
    } else if(this.subEvent === 'tbi') {
      ret.subEvent = Object.assign({}, ret.event, {
        player: null,
        name: 'assist_tbi',
      })
    }
    return ret
  }

  get team() {
    var team = this.$team || (this.player && this.player.team)
    if(team && this.event === 'own_goal') return this.match.opposing(team)
    return team
  }

  set team(v) {
    this.$team = v
  }

  get canSubPlayer() {
    if(this.subEvent === 'tbi') return false
    return (this.event || '').match(/goal|substitution/) &&
      this.player &&
      this.subEvent
  }

  get isReady() {
    return (
      this.event && (
        this.player ||
        (this.team && this.event === 'goal') ||
        this.event === 'ping'
      ) &&
      (
        this.event === 'blunder' ||
        !this.subEvent ||
        this.subEvent === 'tbi' ||
        this.event.match(/bonus/) ||
        this.subPlayer
      )
    )
  }
}

export default function getState(match) {
  return states[match] || (states[match] = new EventState(match))
}
